document.addEventListener('DOMContentLoaded', function () {
  const voiceSearchButton = document.getElementById('voiceSearchButton');
  const searchBox = document.getElementById('drawerSearchInput');
  const searchForm = document.querySelector('.header-search__form');
  const micModal = document.getElementById('micModal');
  let recognizing = false;

  voiceSearchButton.addEventListener('click', function (event) {
    event.preventDefault();
    if (!recognizing) {
      startVoiceRecognition();
    }
  });

  function startVoiceRecognition() {
    recognizing = true;
    micModal.classList.remove('hidden');

    navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
      const mediaRecorder = new MediaRecorder(stream, { mimeType: 'audio/webm;codecs=opus' });
      let audioChunks = [];

      mediaRecorder.ondataavailable = function (event) {
        audioChunks.push(event.data);
      };

      mediaRecorder.onstop = function () {
        const audioBlob = new Blob(audioChunks, { type: 'audio/webm;codecs=opus' });
        const reader = new FileReader();

        reader.onloadend = function () {
          const audioContent = reader.result.split(',')[1];
          sendAudioToGoogleSpeechToText(audioContent);
        };

        reader.readAsDataURL(audioBlob);
        micModal.classList.add('hidden');
        recognizing = false;
      };

      mediaRecorder.start();

      setTimeout(function () {
        mediaRecorder.stop();
      }, 5000);
    }).catch(function (err) {
      console.error('Error accessing microphone:', err);
      micModal.classList.add('hidden');
      recognizing = false;
    });
  }

  function sendAudioToGoogleSpeechToText(audioContent) {
    const API_KEY = window.themeSettings.speech_to_text_api_key;
    const googleSpeechEndpoint = `https://speech.googleapis.com/v1/speech:recognize?key=${API_KEY}`;

    const requestPayload = {
      config: {
        encoding: "WEBM_OPUS",
        sampleRateHertz: 48000,
        languageCode: "en-US"
      },
      audio: {
        content: audioContent
      }
    };

    console.log("Sending request to Google Speech-to-Text API:", requestPayload);

    fetch(googleSpeechEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestPayload)
    })
    .then(response => response.json())
    .then(data => {
      if (data.results && data.results.length > 0) {
        const transcript = data.results[0].alternatives[0].transcript;
        console.log(transcript);
        if (!transcript) {
          alert("Please speak into the mic");
          return;
        }
        searchBox.value = transcript;
        searchForm.submit();
      } else {
        console.log('No speech detected.');
      }
    })
    .catch(error => {
      console.error('Error recognizing speech:', error);
    });
  }
});